import {getRefreshToken} from "../credential_manager";

export async function AuthClient(endpoint:string, method="GET", body: any | undefined = undefined){
    const baseUrl = "https://api.pennypusher.net"

    let headers = {
        'Content-Type': 'application/json',
    };

    let config: RequestInit = {
        method: method,
        headers: {
            ...headers,
        },
    };

    if (body !== undefined) {
        config.body = JSON.stringify(body);
    }

    let data;
    try{
        const response = await fetch(encodeURI(baseUrl+endpoint), config)
        if (response.ok){
            data = await response.json();
            return{
                status: response.status,
                data: data,
                url: response.url
            }
        }
        throw new Error(response.statusText)
    } catch (e: any) {
        return Promise.reject(e.message ? e.message:data)
    }
}

AuthClient.GetAccessToken = function (username: string, password: string){
    const body = {
        "username": username,
        "password": password
    }
    return AuthClient("/api/token", "POST", body);
}

AuthClient.RefreshAccessToken = function (){
    const refreshToken = getRefreshToken();
    const body = {
        "refresh": refreshToken!,
    }
    return AuthClient("/api/token", "POST", body);
}

AuthClient.Register = function ( email: string, password: string, first_name: string, last_name: string){
    const body = {
        "password": password,
        "email": email,
        "first_name": first_name,
        "last_name": last_name
    }
    return AuthClient("/api/v1/user/register/", "POST", body);
}
